import {Accordion} from './Accordion'
import {CollapseButton} from './CollapseButton'
import {Footer} from './Footer'
import {Item} from './Item'
import {Root} from './Root'
import {Section} from './Section'
import {ShowMore} from './ShowMore'
import Search from './Search'

export type {SidebarProps} from './Root'
export type {SectionProps as SidebarSectionProps} from './Section'
export type {ItemProps as SidebarItemProps} from './Item'
export type {AccordionProps as SidebarAccordionProps} from './Accordion'
export type {ShowMoreProps as SidebarShowMoreProps} from './ShowMore'
export type {CollapseButtonProps as SidebarCollapseButtonProps} from './CollapseButton'
export type {SearchProps} from './Search'

export const Sidebar: typeof Root & {
  Footer: typeof Footer
  Section: typeof Section
  Item: typeof Item
  Accordion: typeof Accordion
  Search: typeof Search
  ShowMore: typeof ShowMore
  CollapseButton: typeof CollapseButton
} = Object.assign(Root, {
  Footer,
  Section,
  Item,
  Accordion,
  Search,
  ShowMore,
  CollapseButton,
})
